// extracted by mini-css-extract-plugin
module.exports = {"box":"Landing_box__2M_CE","title":"Landing_title__eBdNa","btn":"Landing_btn__3HZLZ"};